<template>
  <tr>
    <td v-for="column in columns" v-show="isVisibile(column)" :style="{ whiteSpace: column.isMultiLine ? 'normal' : 'nowrap' }" :title="row[column.fieldName] !== -1 ? row[column.fieldName] : ''">
      <span v-if="column.isStatus">
        <i v-if="column.fieldName==='IsUSB' && row[column.fieldName]" class="icon fa fa-usb" title="USB Client"></i>
        <i v-else-if="column.fieldName==='IsUSB' && !row[column.fieldName]" class="icon fa fa-sitemap" title="Network Client"></i>
        <i v-else class="fa fa-circle" :style="{ color: getStatusColor(row[column.fieldName]) }"></i>
        <!--<img v-if="column.fieldName==='IsUSB' && row[column.fieldName]" src="../../../static/img/USB icon.png" alt="USB Printer" title="USB Printer" style="width: 20px; height: 20px;" />
        <img v-else-if="column.fieldName==='IsUSB' && !row[column.fieldName]" src="../../../static/img/LAN icon.png" alt="Network Printer" title="Network Printer" style="width: 18px; height: 18px;" />
        <i v-else class="fa fa-circle" :style="{ color: getStatusColor(row[column.fieldName]) }"></i>-->
      </span>
      <span v-else-if="column.isIcon" class="spanCenter">
        <i :class="[getIconClass(row[column.fieldName])]" style="font-size: 20px;"></i>
      </span>
      <span v-else-if="column.isLink">
        <router-link tag="a" target='_blank' :to="{ name: column.route, params: { printerKey: row[column.param]} }">
          {{row[column.fieldName]}}
        </router-link>
      </span>
      <span v-else-if="column.isBool" class="spanCenter">
        <i v-if="row[column.fieldName]" class="fa fa-check text-green"></i>
        <i v-else class="fa fa-times text-red"></i>
      </span>
      <span v-else-if="column.isActive" class="spanCenter" @click="$emit('click', 'Activate', row)">
        <i v-if="row[column.fieldName]" class="fa fa-toggle-on text-green"></i>
        <i v-else class="fa fa-toggle-on text-red rotate180"></i>
      </span>
      <span v-else-if="column.isLock" class="spanCenter" @click="$emit('click', 'Lock', row)">
        <i v-if="row[column.fieldName]" class="fa fa-lock text-red"></i>
        <i v-else class="fa fa-unlock text-green"></i>
      </span>
      <span v-else-if="column.isProgress" v-show="row[column.fieldName] >= 0">
        <div class="progress-group" style="width: 80px;" v-show="row[column.fieldName] >= 0">
          <div class="progress sm" style="background-color: #ccc; height: 20px;">
            <div :class="['progress-bar', column.fieldName]" :style="{ width: row[column.fieldName] + '%' }">{{row[column.fieldName]}}%</div>
            <!--<div :class="['progress-bar', column.fieldName]" :style="{ width: row[column.fieldName] }">{{row[column.fieldName]}}</div>-->
          </div>
        </div>
      </span>
      <span v-else-if="column.fieldName !== 'VueBottons'">
        <i v-if="false && row.IsNew && column.fieldName==='MacAddress'" class="fa fa-star text-yellow" title="New Printer"></i>
        <!--<img v-if="row.IsUSB && column.fieldName==='ModelName'" src="../../../static/img/USB icon.png" alt="USB Printer" title="USB Printer" style="width: 20px; height: 20px;" />
  <img v-if="!row.IsUSB && column.fieldName==='ModelName'" src="../../../static/img/LAN icon.png" alt="Network Printer" title="Network Printer" style="width: 18px; height: 18px;" />-->
        <i v-if="column.fieldName==='ModelName' && row.CounterStatus==='Error'" class="fa fa-star text-red" title="Wrong Counters!!"></i>
        <i v-if="column.fieldName==='DeviceCode'" class="fa fa-edit text-grey" style="cursor:pointer;" @click="$emit('click', column.fieldName, row)"></i>
        <div :style="{ whiteSpace: column.isMultiLine ? 'normal' : 'nowrap' }"
             :class="[column.className, (row.IsNew && column.fieldName==='MacAddress')?'newLable':'']"
             v-html="$root.shortText(row[column.fieldName], column.length)">
        </div>
      </span>
      <div v-else style="text-align: right;">
        <a v-for="btn in column.bottons" :title="btn.label" class="btn-flat" style="margin-left: 10px; font-size: 20px; cursor: pointer;">
          <router-link v-if="btn.isLink && btn.name==='InfoPrinter'" tag="a" target='_blank' :to="{ name: btn.route, params: { printerKey: row[btn.param]} }">
            <i :class="[getBtnClass(btn, column, row)]" :style="{ color: btn.color }"></i>
          </router-link>
          <router-link v-else-if="btn.isLink && btn.name==='HistoryPrinter'" tag="a" target='_blank' :to="{ name: btn.route, params: { printerKey: row[btn.param]} }">
            <i :class="[getBtnClass(btn, column, row)]" :style="{ color: btn.color }"></i>
          </router-link>
          <router-link v-else-if="btn.isLink && btn.name==='DealerInfo'" v-show="row[btn.param]" tag="a" target='_blank' :to="{ name: btn.route, params: { dealerKey: row[btn.param]} }">
            <i :class="[getBtnClass(btn, column, row)]" :style="{ color: btn.color }"></i>
          </router-link>
          <i v-else @click="$emit('click', btn.name, row)" :class="[getBtnClass(btn, column, row)]" :style="{ color: btn.color }"></i>
        </a>
      </div>
    </td>
  </tr>
</template>
<script>
  export default {
    props: ['row', 'columns', 'options'],
    mounted () {
      // console.log(this.columns[0].fieldName + ' = ' + this.row[this.columns[0].fieldName])
      // console.log('Length = ' + this.row[this.columns[0].fieldName].length)
    },
    updated () {
      // console.log(this.columns[0].fieldName + ' = ' + this.row[this.columns[0].fieldName])
      // console.log('Length = ' + this.row[this.columns[0].fieldName].length)
    },
    methods: {
      isVisibile (column) {
        if (column.isHidden) {
          return false
        }
        if (column.filterKey) {
          // console.log('this.options.activeFilter = ' + this.options.activeFilter)
          if (this.options.activeFilter === column.filterKey || this.options.activeFilter === 'All') {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      isNew (row) {
        let vm = this
        if (vm.$route.name === 'Printers') {
          var today = vm.$moment()
          var logDay = vm.$moment(row.Logged, 'YYYY-MM-DD HH:mm:ss')
          let diffDays = today.diff(logDay, 'days')
          if (diffDays <= 14) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      getIconClass (ruleType) {
        for (let i = 0; i < this.$root.alertTypes.length; i++) {
          if (this.$root.alertTypes[i].value === ruleType) {
            return this.$root.alertTypes[i].iconClass
          }
        }
        return ''
      },
      getBtnClass (btn, column, row) {
        if (btn.name === 'RefreshPrinter') {
          if (btn.fieldName && btn.fieldName === 'IsRefresh') {
            if (row[btn.fieldName] === 'Refresh') {
              return btn.iconClass + ' fa-spin text-red'
            } else if (row[btn.fieldName] === 'Progress') {
              return btn.iconClass + ' fa-spin text-dark-green'
            } else {
              return btn.iconClass
            }
          } else {
            return btn.iconClass
          }
        } else if (btn.name === 'RestartClient') {
          if (btn.fieldName && btn.fieldName === 'IsRestart') {
            if (row[btn.fieldName] === 'Restart') {
              return btn.iconClass + ' text-red'
            } else if (row[btn.fieldName] === 'InProgress') {
              return btn.iconClass + ' blink text-orange'
            } else if (row[btn.fieldName] === 'Running') {
              return btn.iconClass + ' text-green'
            } else {
              return btn.iconClass
            }
          } else {
            return btn.iconClass + ' text-green'
          }
        } else {
          return btn.iconClass
        }
      },
      getStatusColor (status) {
        if (status === true) { return true }
        if (status === false) { return false }
        if (status === 'Deleted') { return '#d2d6de' }
        if (status) {
          if (status.trim().toLowerCase().indexOf('ready') > -1) {
            return 'green'
          }
          if (status.trim().toLowerCase().indexOf('sleep') > -1) {
            return 'green'
          }
          if (status.trim().toLowerCase().indexOf('idle') > -1) {
            return 'green'
          }
          if (status.trim().toLowerCase().indexOf('disconnect') > -1) {
            return 'red'
          }
          if (status.trim().toLowerCase().indexOf('connect') > -1) {
            return 'green'
          }
          if (status.trim().toLowerCase().indexOf('online') > -1) {
            return 'green'
          }
          if (status.trim().toLowerCase().indexOf('sleep') > -1) {
            return 'green'
          }
          if (status.trim().toLowerCase().indexOf('energy') > -1) {
            if (status.trim().toLowerCase().indexOf('save') > -1) {
              return 'green'
            }
          }
          if (status.trim().toLowerCase().indexOf('power') > -1) {
            if (status.trim().toLowerCase().indexOf('save') > -1) {
              return 'green'
            }
            if (status.trim().toLowerCase().indexOf('mode') > -1) {
              return 'green'
            }
          }
          if (status.trim().toLowerCase().indexOf('printing') > -1) {
            return 'green'
          }
          // rinter.ErrorString
          switch (status.trim().toLowerCase()) {
            case 'online': return 'green'
            case 'idle(3)': return 'green'
            case 'connected': return 'green'
            case 'ready': return 'green'
            case 'offline': return 'red'
            case 'disconnected': return 'red'
            case 'sleep': return 'green'
            case 'energy saver mode': return 'green'
            case 'power saver': return 'green'
            case 'powersave on': return 'green'
            case 'power down mode.': return 'green'
            default: return 'darkorange'
          }
        } else {
          return 'darkorange'
        }
      }
    }
  }
</script>
<style>
  .text-dark-green {
    color: rgb(0, 128, 0) !important;
  }
  .blink {
    animation: blink 2s steps(5, start) infinite;
    -webkit-animation: blink 1s steps(5, start) infinite;
  }
    @keyframes blink {
      to {
        visibility: hidden;
      }
    }
    @-webkit-keyframes blink {
      to {
        visibility: hidden;
      }
    }
  thead > tr > th {
    color: #666;
    padding: 5px !important;
    vertical-align: middle !important;
  }
  tbody > tr:hover {
    background: #eee !important;
  }
  tbody > tr > td {
    color: #666;
    padding: 5px !important;
    vertical-align: middle !important;
    height: 40px !important;
  }
  .spanCenter {
    display: block;
    text-align: center;
  }
  .spanCenter > i{
    font-size: 20px;
    cursor: pointer;
  }
  .authKey {
    font-family: "Courier New", Courier, monospace;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1px;
  }
</style>



// WEBPACK FOOTER //
// TableRow.vue?da0e31ae